module.exports = __webpack_public_path__ + "img/logo-light.cbd5733c.png";